import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { CalendarIcon, TagIcon, ArrowLeftIcon, UserIcon } from '@heroicons/react/24/outline';
import apiService from '../services/api';
import 'react-quill/dist/quill.snow.css';

interface NewsItem {
  _id: string;
  title: string;
  category: string;
  summary: string;
  content: string;
  author: string;
  tags: string[];
  isPublished: boolean;
  publishDate?: string;
  viewCount: number;
  coverImage?: string;
  createdAt: string;
  updatedAt: string;
}

const NewsDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [news, setNews] = useState<NewsItem | null>(null);
  const [loading, setLoading] = useState(true);

  console.log('NewsDetail组件渲染，ID:', id, 'loading:', loading, 'news:', news);

  useEffect(() => {
    const fetchNewsDetail = async () => {
      try {
        setLoading(true);
        console.log('获取新闻详情，ID:', id);
        const response = await apiService.get<any>(`/news/${id}`);
        console.log('新闻详情API响应:', response);
        console.log('新闻详情数据:', response.data);
        setNews(response.data || null);
      } catch (error) {
        console.error('获取新闻详情失败:', error);
        setNews(null);
      } finally {
        setLoading(false);
      }
    };
    if (id) fetchNewsDetail();
  }, [id]);

  if (loading) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded mb-4"></div>
          <div className="h-4 bg-gray-200 rounded mb-2"></div>
          <div className="h-4 bg-gray-200 rounded mb-8"></div>
          <div className="h-64 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  if (!news) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 text-center text-gray-400">
        未找到该新闻
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <button
        onClick={() => navigate(-1)}
        className="mb-6 flex items-center text-primary-600 hover:underline"
      >
        <ArrowLeftIcon className="h-5 w-5 mr-1" /> 返回新闻列表
      </button>
      <div className="mb-4 flex items-center space-x-4">
        <span className="inline-block bg-primary-100 text-primary-800 text-xs px-2 py-1 rounded">
          {news.category}
        </span>
        <div className="flex items-center text-sm text-gray-500">
          <CalendarIcon className="h-4 w-4 mr-1" />
          {new Date(news.createdAt).toLocaleDateString()}
        </div>
        <div className="flex items-center text-sm text-gray-500">
          <UserIcon className="h-4 w-4 mr-1" />
          {news.author}
        </div>
      </div>
      <h1 className="text-3xl font-bold text-gray-900 mb-4">{news.title}</h1>
      <p className="text-gray-600 mb-6 leading-relaxed">{news.summary}</p>
      
      {/* 封面图片 */}
      {news.coverImage && (
        <div className="mb-6">
          <img
            src={news.coverImage}
            alt={news.title}
            className="w-full max-w-2xl h-auto rounded-lg shadow-lg"
          />
        </div>
      )}
      
      <div 
        className="prose max-w-none mb-8 ql-editor" 
        dangerouslySetInnerHTML={{ __html: news.content }}
        style={{
          fontSize: '16px',
          lineHeight: '1.6',
          color: '#374151'
        }}
      />
      <div className="flex items-center space-x-2">
        <TagIcon className="h-4 w-4 text-gray-400" />
        <div className="flex space-x-1">
          {news.tags?.map((tag) => (
            <span key={tag} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsDetail; 